import React from 'react'
import { theme } from 'theme'
import Text from 'particles/Text'
import { ReadOnlyContainer } from './style'
import Icon from 'components/Icon'
import NoValue from './NoValue'
interface TextReadOnlyProps {
    minHeight?: string
    isTextArea?: boolean
    value: string
    isDate?: boolean
    noValueContext?: string
}
const TextReadOnly: React.FC<TextReadOnlyProps> = ({
    minHeight,
    value,
    isTextArea = false,
    isDate = false,
    noValueContext,
}) => {
    const flexAlign = isTextArea ? 'flex-start' : 'center'

    return (
        <>
            {Boolean(value) ? (
                <ReadOnlyContainer minHeight={minHeight} flexAlign={flexAlign}>
                    {isDate && <Icon.CalendarBlankIcon color={theme.newColors.neutral500} weight="bold" />}
                    <Text scale="bodyS700" color="primary">
                        {value}
                    </Text>
                </ReadOnlyContainer>
            ) : (
                <NoValue context={noValueContext} />
            )}
        </>
    )
}
export default TextReadOnly
